// Logging utility with Service and Action enums
export enum Service {
  AUTH_SERVICE = 'AUTH_SERVICE',
  OPTIMIZATION_SERVICE = 'OPTIMIZATION_SERVICE',
  JOB_SCRAPING_SERVICE = 'JOB_SCRAPING_SERVICE',
  CREDIT_SERVICE = 'CREDIT_SERVICE',
  ANALYTICS_SERVICE = 'ANALYTICS_SERVICE',
  PAYMENT_SERVICE = 'PAYMENT_SERVICE',
  NOTIFICATION_SERVICE = 'NOTIFICATION_SERVICE',
  USER_SERVICE = 'USER_SERVICE',
  USER_IDENTITY_SERVICE = 'USER_IDENTITY_SERVICE',
  RESUME_SERVICE = 'RESUME_SERVICE',
  APPLICATION_SERVICE = 'APPLICATION_SERVICE',
  DASHBOARD_SERVICE = 'DASHBOARD_SERVICE',
  SYSTEM = 'SYSTEM'
}

export enum Action {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  CREATE = 'CREATE',
  READ = 'READ',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  PROCESS = 'PROCESS',
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
  UPDATE_PROFILE = 'UPDATE_PROFILE'
}

// Simple logger implementation
export const logger = {
  info: (service: Service, action: Action, message: string, data?: unknown) => {
    console.log(`[${service}] [${action}] ${message}`, data || '');
  },
  error: (service: Service, action: Action, message: string, data?: unknown) => {
    console.error(`[${service}] [${action}] ${message}`, data || '');
  },
  warn: (service: Service, action: Action, message: string, data?: unknown) => {
    console.warn(`[${service}] [${action}] ${message}`, data || '');
  },
  debug: (service: Service, action: Action, message: string, data?: unknown) => {
    console.debug(`[${service}] [${action}] ${message}`, data || '');
  },
  success: (service: Service, action: Action, message: string, data?: unknown) => {
    console.log(`[${service}] [${action}] ✅ ${message}`, data || '');
  }
};

// Convenience functions for backward compatibility
export const logInfo = (service: Service, action: Action, message: string, data?: unknown) => {
  logger.info(service, action, message, data);
};

export const logError = (service: Service, action: Action, message: string, data?: unknown) => {
  logger.error(service, action, message, data);
};

export const logWarn = (service: Service, action: Action, message: string, data?: unknown) => {
  logger.warn(service, action, message, data);
};

export const logDebug = (service: Service, action: Action, message: string, data?: unknown) => {
  logger.debug(service, action, message, data);
};
